module.exports = __webpack_public_path__ + "img/icon379.081e851d.png";